import { Switch } from '@mui/material';
import { FormControlLabel } from '@mui/material';
import LocalizeInput from 'components/input/LocalizeInput';
import ModifyButtons from 'components/layouts/ModifyButtons';
import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button, UIStore, useModelStateContext } from 'saladsoft-primitive';
import { AdminTagRequestDto } from 'services/data-contracts';
import ServiceHelper from 'stores/ServiceHelper';
import { useStoreWrapper } from 'stores/StoreHelper';
import { TagModel } from 'types/CommonTypes';

const TagForm = ({ onSave, tag }: { onSave: (tag?: TagModel) => void; tag?: TagModel }) => {
  const { setState, stateModel } = useModelStateContext<AdminTagRequestDto>();
  const { uiStore } = useStoreWrapper();

  const handleClickSave = async () => {
    let result: any;
    if (tag?.id) {
      result = await ServiceHelper.adminTagService?.updateTag(
        tag?.id as number,
        stateModel as AdminTagRequestDto,
      );
    } else {
      result = await ServiceHelper.adminTagService?.createTag(stateModel as AdminTagRequestDto);
    }

    if (result?.status && result.status < 300) {
      uiStore?.modal.close();
      toast.success('태그 추가 완료');
      onSave?.(result.data as TagModel);
    }
  };

  const handleClickDelete = () => {
    if (tag?.id) {
      ServiceHelper.adminTagService?.deleteTag(tag.id).then((res) => {
        if (res?.status && res.status < 300) {
          toast.success('태그 삭제 완료');
          onSave?.();
          uiStore?.modal.close();
        } else {
          toast.error('태그 삭제 실패');
        }
      });
    }
  };

  useEffect(() => {
    if (tag) {
      setState('localizedName', tag.localizedName);
    }
  }, [tag]);

  return (
    <div>
      <LocalizeInput
        defaultValue={tag?.localizedName}
        onChange={(value) => setState('localizedName', value)}
      />
      <div></div>
      <ModifyButtons
        showDelete={tag?.id ? true : false}
        type={tag?.id ? 'update' : 'create'}
        onCancel={() => uiStore?.modal.close()}
        onSave={() => {
          handleClickSave();
        }}
        onDelete={() => {
          uiStore?.confirm.show({
            title: '태그 삭제',
            message: '태그를 삭제하시겠습니까?',
            onConfirmed: () => {
              handleClickDelete();
            },
          });
        }}
      />
      {/* <Button
        style={{ marginTop: 20 }}
        onClick={async () => {
          if (stateModel) {
            const result = await ServiceHelper.adminTagService?.createTag(stateModel);
            if (result?.status && result.status < 300) {
              uiStore?.modal.close();
              toast.success('태그 추가 완료');
              onSave?.(result.data as TagModel);
            }
          }
        }}
      > */}
    </div>
  );
};

export default TagForm;
